import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material";

@Component({
  selector: 'app-restricted-email',
  templateUrl: './restricted-email.component.html',
  styleUrls: ['./restricted-email.component.css']
})
export class RestrictedEmailComponent implements OnInit {

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/login-signup/restricted-email/restricted-email.component.ts